import { alertMessagesArgsConfig, collectionArgsConfig } from '../utils/event_constants';

export const importExportAcions = [
  {
    name: 'exportCollectionItem',
    label: 'Export Collection Item',
    args: [
      collectionArgsConfig,
      {
        name: 'filterId',
        label: 'Select Filter',
        type: 'dropdown',
        optionsType: 'filterApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'importCollectionItem',
    label: 'Import Collection Item',
    args: [collectionArgsConfig, ...alertMessagesArgsConfig],
  },
];
